interface IPlatformNotifications {
    supported: boolean
    configured: boolean
}

export const getPlatformNotifications = (): IPlatformNotifications => {
    return (
        (window as any).PlatformNotifications ?? {
            supported: false,
            configured: false,
        }
    )
}
